
function parseJSON(response) {
    return response.json()
}


/**
 * 将类似的配置文件转换成json：需注意，仅对多个 = 符号的行进行转换
 * 例：record.data.event.url=http://record.olacio.com/record/data/event/{roomId}/{name}?date={date}，
 * 转换为：{ "record.data.event.url": "http://record.olacio.com/record/data/event/{roomId}/{name}?date={date}" }
 * */ 
function propertiesToJson(str) {

    const result = {};

    // 找到类似record.data.event.url=http://record.olacio.com/record/data/event/{roomId}/{name}?date={date}的行
    const lineArr = str.split('\n');

    // 使用foreach遍历lineArr
    lineArr.forEach(line => { 
        
        if (line.includes('=')) {
            const key = line.substring(0, line.indexOf('='));
            const value = line.substring(line.indexOf('=') + 1);

            result[key] = value;
        }
    });

    return result;
}

function tranToString(response) {
    return response.text()
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    }

    const error = new Error(response.statusText)
    error.response = response
    throw error
}

export const requestData = function (url, options) {
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => ({
            data
        }))
        .catch(err => ({
            err
        }))
}


export const requestProperties = function (url, options) {
    return fetch(url, options)
        .then(tranToString)
        .then(propertiesToJson)
}
